// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// - Header is persistently sticky on all pages (always visible at top).
// - Homepage: starts transparent, transitions to white after scrolling
//   partway through the hero (before the hero fully clears the header).
// - All other pages: always white with a grey border (default CSS state).
//
// ----------------------------------------------------------------------------

// Styles
import './_header--sticky.scss';

// Selectors
var HEADER_SELECTOR = '#shopify-section-header';
var HERO_SELECTOR = '[data-section-type="hero-home"], .page-hero';

// Classes
var STICKY_CLASS = 'is-sticky';
var TRANSPARENT_HEADER_WHITE_BUFFER_PX = 100;
document.addEventListener('DOMContentLoaded', function () {
  var headerSection = document.querySelector(HEADER_SELECTOR);
  if (!headerSection) return;

  // Non-homepage pages are always white (CSS default). No scroll toggling needed.
  var isHomepage = document.body.classList.contains('template-index');
  if (!isHomepage) return;

  // Homepage: add is-sticky once the user scrolls past the hero.
  var heroSection = document.querySelector(HERO_SELECTOR);
  function getScrollThreshold() {
    if (heroSection) {
      return Math.max(0, headerSection.offsetHeight + TRANSPARENT_HEADER_WHITE_BUFFER_PX);
    }
    // Fallback: any scroll triggers the white state.
    return 0;
  }
  function updateStickyState() {
    var scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > getScrollThreshold()) {
      headerSection.classList.add(STICKY_CLASS);
    } else {
      headerSection.classList.remove(STICKY_CLASS);
    }
  }
  updateStickyState();
  window.addEventListener('scroll', updateStickyState, {
    passive: true
  });
});